import React from 'react';
import SliderFunctional from './component/slider-functional';
import './slider.scss';

const SliderPage = () => {
	return <SliderFunctional />;
};
export default SliderPage;
